export const getSmartImage = (src?: string, fileName?: string) => {
  const file = fileName?.toLocaleLowerCase() || src?.toLowerCase();

  if (!file) return '/images/other.png';

  if (
    file.endsWith('.doc') ||
    file.endsWith('.docx') ||
    file.endsWith('.pages') ||
    file.endsWith('.txt') ||
    file.endsWith('.pdf')
  ) {
    return '/images/text.png';
  }
  if (
    file.endsWith('.xls') ||
    file.endsWith('.xlsx') ||
    file.endsWith('.csv') ||
    file.endsWith('.dat') ||
    file.endsWith('.db') ||
    file.endsWith('.sql') ||
    file.endsWith('.sav') ||
    file.endsWith('.xml') ||
    file.endsWith('.numbers')
  ) {
    return '/images/data.png';
  }
  if (
    file.endsWith('.ppt') ||
    file.endsWith('.pptx') ||
    file.endsWith('.key') ||
    file.endsWith('.pps') ||
    file.endsWith('.odp')
  ) {
    return '/images/presentation.png';
  }
  if (
    file.endsWith('.tif') ||
    file.endsWith('.tiff') ||
    file.endsWith('.bmp') ||
    file.endsWith('.jpg') ||
    file.endsWith('.eps') ||
    file.endsWith('.gif') ||
    file.endsWith('png') ||
    file.endsWith('.jpeg') ||
    file.endsWith('.jfif') ||
    file.endsWith('.webp') ||
    file.endsWith('.apng') ||
    file.endsWith('.avif') ||
    file.endsWith('.svg')
  ) {
    return src;
  }
  return '/images/other.png';
};
